/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Token } from '../models';
/**
 * AuthorizationApi - axios parameter creator
 * @export
 */
export const AuthorizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authenticate a customer using username/password
         * @param {string} username The customer\&#39;s username
         * @param {string} password The customer\&#39;s password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate: async (username: string, password: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('authenticate', 'username', username)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('authenticate', 'password', password)
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticate a customer using Apple sign on token
         * @param {string} token Apple JWT
         * @param {string} code Apple authorization code
         * @param {string} [fullName] The full name of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithApple: async (token: string, code: string, fullName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authenticateWithApple', 'token', token)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('authenticateWithApple', 'code', code)
            const localVarPath = `/api/auth/apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (fullName !== undefined) {
                localVarQueryParameter['fullName'] = fullName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticate a customer using a Google JWT token
         * @param {string} token Google JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithGoogle: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authenticateWithGoogle', 'token', token)
            const localVarPath = `/api/auth/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticate a customer using a Google access token
         * @param {string} token Google access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithGoogleAccessToken: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authenticateWithGoogleAccessToken', 'token', token)
            const localVarPath = `/api/auth/google/access_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizationApi - functional programming interface
 * @export
 */
export const AuthorizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authenticate a customer using username/password
         * @param {string} username The customer\&#39;s username
         * @param {string} password The customer\&#39;s password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticate(username: string, password: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticate(username, password, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Authenticate a customer using Apple sign on token
         * @param {string} token Apple JWT
         * @param {string} code Apple authorization code
         * @param {string} [fullName] The full name of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateWithApple(token: string, code: string, fullName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateWithApple(token, code, fullName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Authenticate a customer using a Google JWT token
         * @param {string} token Google JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateWithGoogle(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateWithGoogle(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Authenticate a customer using a Google access token
         * @param {string} token Google access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateWithGoogleAccessToken(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateWithGoogleAccessToken(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthorizationApi - factory interface
 * @export
 */
export const AuthorizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizationApiFp(configuration)
    return {
        /**
         * 
         * @summary Authenticate a customer using username/password
         * @param {string} username The customer\&#39;s username
         * @param {string} password The customer\&#39;s password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticate(username: string, password: string, options?: any): AxiosPromise<Token> {
            return localVarFp.authenticate(username, password, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticate a customer using Apple sign on token
         * @param {string} token Apple JWT
         * @param {string} code Apple authorization code
         * @param {string} [fullName] The full name of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithApple(token: string, code: string, fullName?: string, options?: any): AxiosPromise<Token> {
            return localVarFp.authenticateWithApple(token, code, fullName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticate a customer using a Google JWT token
         * @param {string} token Google JWT
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithGoogle(token: string, options?: any): AxiosPromise<Token> {
            return localVarFp.authenticateWithGoogle(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticate a customer using a Google access token
         * @param {string} token Google access token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateWithGoogleAccessToken(token: string, options?: any): AxiosPromise<Token> {
            return localVarFp.authenticateWithGoogleAccessToken(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthorizationApi - object-oriented interface
 * @export
 * @class AuthorizationApi
 * @extends {BaseAPI}
 */
export class AuthorizationApi extends BaseAPI {
    /**
     * 
     * @summary Authenticate a customer using username/password
     * @param {string} username The customer\&#39;s username
     * @param {string} password The customer\&#39;s password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authenticate(username: string, password: string, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authenticate(username, password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticate a customer using Apple sign on token
     * @param {string} token Apple JWT
     * @param {string} code Apple authorization code
     * @param {string} [fullName] The full name of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authenticateWithApple(token: string, code: string, fullName?: string, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authenticateWithApple(token, code, fullName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticate a customer using a Google JWT token
     * @param {string} token Google JWT
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authenticateWithGoogle(token: string, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authenticateWithGoogle(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticate a customer using a Google access token
     * @param {string} token Google access token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public authenticateWithGoogleAccessToken(token: string, options?: AxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).authenticateWithGoogleAccessToken(token, options).then((request) => request(this.axios, this.basePath));
    }
}
